// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__29ISx","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3FRU-"};